export const accountTable = (data) => {
    return data && data.length && data.map((item, index) => {
        return {
            rowId: index + 1,
            ...item
        };
    });
}

export const accountTableTitles = () => {
    return [
        {
            title: 'Google Ads ID',
            alias: 'account_id',
        },
        {
            title: 'Google Ads account',
            alias: 'account_name',
        },
        {
            title: 'Status',
            alias: 'status',
        },
        {
            title: 'Ad clicks',
            alias: 'ad_clicks',
        },
        {
            title: 'Blocked IP',
            alias: 'blocked_ip',
        },
        {
            title: 'Saved budget',
            alias: 'saved_budget',
        },
    ];
}
